/**
 * NOTE: Do not edit or add functions to this file. Usage restricted to import only.
 */

import { Timestamp } from "firebase/firestore";

export default Timestamp;
